export enum DateForm {
    ind_f1 = 'dd/mm/yyyy',
    ind_f2 = 'mm/dd/yyyy',
    ind_f3 = 'yyyy-dd-mm',
    ind_f4 = 'yyyy/mm/dd',
    ind_f5 = 'dd/yyyy/mm',
    ind_f6 = 'mm/yyyy/dd',

    nor_f1 = 'dd.mm.yyyy',
    nor_f2 = 'yyyy.mm.dd',
    nor_f3 = 'yyyy.dd.mm',
    nor_f4 = 'dd.yyyy.dd',
    nor_f5 = 'mm.dd.yyyy',
    nor_f6 = 'mm.yyyy.dd',

    nsg_f1 = 'dd-mm-yyyy',
    nsg_f2 = 'yyyy-dd-mm',
    nsg_f3 = 'mm-dd-yyyy',
    nsg_f4 = 'yyyy-mm-dd',
    nsg_f5 = 'dd-yyyy-mm',
    nsg_f6 = 'mm-yyyy-dd',
}
